var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{style:({height: _vm.height}),attrs:{"fluid":"","src":((_vm.full===true) ? _vm.logoFull : _vm.logo),"alt":_vm.$t('Logo')}})}
var staticRenderFns = []

export { render, staticRenderFns }